import { PARTNER_CONFIG } from '../partner-configs/partnerConfig';

/**
 * Detects source based on current hostname patterns
 * Supports different environments (dev/uat/prod)
 *
 * @returns {string} The detected source identifier
 */
export const detectSourceFromHostname = () => {
  const hostname = window.location.hostname;
  for (const [source, config] of Object.entries(PARTNER_CONFIG)) {
    if (config.hostname && hostname.includes(config.hostname)) {
      return source;
    }
  }
  return null;
};

/**
 * Detects source from legacy path-based routing
 * For backward compatibility
 *
 * @returns {string|null} The detected source identifier or null
 */
export const detectSourceFromPath = () => {
  const pathname = window.location.pathname;
  for (const [source, config] of Object.entries(PARTNER_CONFIG)) {
    if (config.path && pathname.includes(config.path)) {
      return source;
    }
  }
  return null;
};

/**
 * Detects source with priority:
 * 1. Path-based detection (legacy support)
 * 2. Hostname-based detection (for all environments)
 * 3. Environment variable (for local development)
 * 4. Default fallback
 *
 * @returns {string} The detected source identifier
 */
export const detectSource = () => {
  const pathSource = detectSourceFromPath();
  if (pathSource) return pathSource;

  const hostnameSource = detectSourceFromHostname();
  if (hostnameSource) return hostnameSource;

  if (PARTNER_CONFIG[process.env.REACT_APP_DEFAULT_SOURCE]) {
    return process.env.REACT_APP_DEFAULT_SOURCE;
  }

  return 'TFAF_AUTOSURE';
};
